import classNames from "classnames";
import { Link } from "react-router-dom";

import { UserInfoCard } from "@pentabd/ui";

import { extraResponsibilityValues } from "@containers/HRM/EmployeeList/components/EmployeeTable/const";

import { GetEmployeeDetails } from "@utils/getEmployeeDetails";
import { transformToReadableString } from "@utils/transformText";

import { ROUTES } from "@constants/routes";
import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";

const {
  HRM: { EMPLOYEES },
} = ROUTES;

export function ProfileInfoCard({
  employee,
  role,
  weight,
  viewProfile,
}: {
  employee: EmployeeCommonInfoType;
  weight?:
    | "bolder"
    | "bold"
    | "semibold"
    | "medium"
    | "normal"
    | "light"
    | "lighter";
  role?: string;
  viewProfile?: boolean;
}) {
  const { id, isActive } = employee || {};

  const { employeeName, employeePosition, employeeImage } =
    GetEmployeeDetails(employee);

  const CardComponent = () => (
    <div
      className={classNames({
        inactive: isActive !== undefined && isActive !== null && !isActive,
      })}
    >
      <UserInfoCard
        title={`${employeeName} ${
          role ? `(${transformToReadableString(role)})` : ""
        }`}
        subtitle={employeePosition}
        avatarName={employeeName}
        imageURL={employeeImage}
        color={
          role
            ? (role === extraResponsibilityValues.ATTACHMENT && "success") ||
              "warning"
            : "dark"
        }
        weight={weight}
      />
    </div>
  );

  return viewProfile ? (
    <Link to={`${EMPLOYEES}/${id}`} className="text-decoration-none">
      <CardComponent />
    </Link>
  ) : (
    <CardComponent />
  );
}
